import styled from 'styled-components';
import { themes } from 'kb-shared';

export const DescriptionText = styled.p`
  ${themes.fonts.FoundersGrotesk};
  color: ${themes.colors.KBNight};
  white-space: pre-wrap;
  margin-bottom: 34px;
`;

export const Title2 = styled.h2`
  font-size: 18px;
  font-weight: bold;
`;

export const Container = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  margin-top: 100px;

  a {
    text-decoration: underline;
  }
`;

export const CareTeamPeople = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  margin-top: 33px;
`;

export const PersonWrapper = styled.div`
  margin-bottom: 30px;

  .responsability {
    font-size: 14px;
    text-transform: uppercase;
  }

  .name {
    ${themes.fonts.DomaineDisplay};
    font-weight: bold;
    font-size: 22px;
  }
`;
